import { api } from "./client";
import type { APIResponse, User, UserProfileResponse } from "./types";

export type UpdateProfileData = {
	firstName: string;
	lastName: string;
	email?: string | null;
	phoneNumber?: string | null;
	username?: string | null;
};

export type PartialUser = {
	userId: string;
	hasCompletedOnboarding: boolean;
	firstName?: string;
	lastName?: string;
	username: string;
};

export type OnboardingData = {
	firstName: string;
	lastName: string;
	profilePicture: File | null;
	username?: string;
};

export type UpdateSocialsData = {
	instagram?: string | null;
	twitter?: string | null;
	snapchat?: string | null;
	spotify?: string | null;
	appleMusic?: string | null;
};

export const userApi = {
	getPartialUser: async () => {
		return api<APIResponse<PartialUser>>("/user/partial");
	},

	updateProfile: async (data: UpdateProfileData) => {
		return api<APIResponse<User>>("/user/info", {
			method: "PUT",
			body: data,
		});
	},

	updateSocials: async (data: UpdateSocialsData) => {
		return api<APIResponse<User>>("/user/socials", {
			method: "PUT",
			body: data,
		});
	},

	onboardUser: async (data: OnboardingData) => {
		const formData = new FormData();

		// Add each field directly to form data
		for (const [key, value] of Object.entries(data)) {
			if (key === "profilePicture") {
				if (value !== null) {
					formData.append(key, value as File);
				}
			} else {
				formData.append(key, value as string);
			}
		}

		return api<APIResponse<User>>("/user/onboarding", {
			method: "PUT",
			body: formData,
		});
	},

	getUserProfile: async (username: string) => {
		return api<APIResponse<UserProfileResponse>>(`/user/profile/${username}`);
	},

	updateProfilePicture: async (file: File) => {
		const formData = new FormData();
		formData.append("profilePicture", file);

		return api<APIResponse<User>>("/user/profile-picture", {
			method: "PUT",
			body: formData,
		});
	},
};
